module.exports = __webpack_public_path__ + "admin/img/module_icon_treasury.8ac0fa81.svg";